import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';
import type { CollaborationUser } from './useListCollaborationUsers';

const listInvoiceCollaborationUsers = async (
    sessionId: string,
    invoiceId: string,
): Promise<CollaborationUser[]> => {
    const { data } = await axios.get(`${API_URL}/invoice/collaborate/list-users`, {
        params: { invoiceId },
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useListInvoiceCollaborationUsers = (invoiceId: string) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/invoice/collaborate/list-users', invoiceId],
        queryFn: () => listInvoiceCollaborationUsers(sessionContext?.sessionId ?? '', invoiceId),
        enabled: !!sessionContext?.sessionId && !!invoiceId,
        staleTime: 3 * 1000,
        refetchInterval: 3 * 1000,
    });
};
